document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-thumbnail-grid").forEach(grid => {
    grid.classList.add("is-collapsed");

    const buttons = grid.parentElement.querySelectorAll(".thumbnail-show-more");

    buttons.forEach(button => {
      button.addEventListener("click", () => {
        const expanded = button.dataset.expanded === "true";

        // Keep both buttons in sync
        buttons.forEach(btn => {
          btn.dataset.expanded = expanded ? "false" : "true";
          // data-label: z. B. "Alle 39 anzeigen" (A/B-Test Design-Auswahl), sonst wie bisher "Alle anzeigen"
          btn.innerHTML = expanded ? (btn.dataset.label || "Alle anzeigen") : "Weniger anzeigen";
        });

        if (expanded) {
          grid.classList.add("is-collapsed");
        } else {
          grid.classList.remove("is-collapsed");
        }
      });
    });
  });
});